export type ActionMode =
    'idle' | 'start' | 'pause' | 'stop' | 'scan' | 'forceAligner' | 'cancelAligner';

/** Held by the modal, so Escape can leave the open step and never drop a typed scan message. */
export interface ActionSteps {
    mode: ActionMode;
    setMode: (mode: ActionMode) => void;
    scanMessage: string;
    setScanMessage: (message: string) => void;
}

/** Escape leaves an open step like Cancel, but never drops a typed message or unsaved settings. */
export function escapeAction(
    mode: ActionMode,
    scanMessage: string,
    unsavedChanges: number
): 'back' | 'close' | 'none' {
    if (mode === 'idle') return unsavedChanges === 0 ? 'close' : 'none';
    return mode === 'scan' && scanMessage.trim() !== '' ? 'none' : 'back';
}
